export default __webpack_public_path__ + "static/media/circle-lightning.e7f869e1.svg";